<ion-grid class="confirmation-body">
  <ion-row>

    <ion-col>
      <div class="center-content justify-content-flex-end">

        <div class="center-content justify-content-flex-end" *ngIf="moduleName == 2">
          <label class="mr-10">Absent</label>
          <mat-slide-toggle class="mr-10" [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
          <label class="mr-10">Present</label>
        </div>
        <div class="center-content justify-content-flex-end" *ngIf="moduleName == 5">
          <label class="mr-10">Approved</label>
          <mat-slide-toggle class="mr-10" [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
          <label class="mr-10">Rejected</label>
        </div>
        <button  class="mr-10 Download fs-16 font_semibold">
          <img src="././assets/icon/yellowdownload.png" class="downIcon">Download
        </button>
        <div class="close_bg display-center cp" [mat-dialog-close]>
          <img src="././assets/icon/close_icon.png" class="closeHeight">
        </div>
      </div>
    </ion-col>
  </ion-row>
 
  <!-- Scrollable Table -->
  <ion-row>
    <ion-col class="p-10" size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="table-container">
        
        <table class="table-scroll" *ngIf="moduleName==1">
          <thead>
            <tr>
              <th> Training Type </th> 
              <th> Program Title</th>  
              <th> Program Code</th> 
              <th> Program Link</th> 
              <th> Faculty</th> 
              <th> Objective</th> 
              <th> Start Date</th> 
              <th> End Date</th> 
              <th>Location</th> 
              <th> Emp name</th> 
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of nominations">
              <td>{{ row.type }}</td>
              <td>{{ row.title }}</td>
              <td>{{ row.code }}</td>
              <td>{{ row.link }}</td>
              <td>{{ row.faculty }}</td>
              <td>{{ row.objective }}</td>
              <td>{{ row.startDate }}</td>
              <td>{{ row.endDate }}</td>
              <td>{{ row.location }}</td>
              <table>
                <tbody>
                  <tr *ngFor="let emp of row.empNames">
                    <td>{{ emp }}</td>
                  </tr>
                </tbody>
              </table>
            </tr>
          </tbody>
        </table>


        <table class="table-scroll" *ngIf="moduleName==2">
          <thead>
            <tr>
              <th> Training Type </th> 
              <th> Program Title</th>  
              <th> Program Code</th> 
              <th> Program Link</th> 
              <th> Faculty</th> 
              <th> Objective</th> 
              <th> Start Date</th> 
              <th> End Date</th> 
              <th>Location</th> 
              <th> Emp name</th> 
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of attended">
              <td>{{ row.type }}</td>
              <td>{{ row.title }}</td>
              <td>{{ row.code }}</td>
              <td>{{ row.link }}</td>
              <td>{{ row.faculty }}</td>
              <td>{{ row.objective }}</td>
              <td>{{ row.startDate }}</td>
              <td>{{ row.endDate }}</td>
              <td>{{ row.location }}</td>
              <table>
                <tbody>
                  <tr *ngFor="let emp of row.empNames">
                    <td>{{ emp }}</td>
                  </tr>
                </tbody>
              </table>
            </tr>
          </tbody>
        </table>


          <table class="table-scroll" *ngIf="moduleName==3">
          <thead>
            <tr>
              <th> Training Type </th> 
              <th> Program Title</th>  
              <th> Program Code</th> 
              <th> Program Link</th> 
              <th> Faculty</th> 
              <th> Objective</th> 
              <th> Start Date</th> 
              <th> End Date</th> 
              <th>Location</th> 
              <th> Emp name</th> 
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of upcomingPrograms">
              <td>{{ row.type }}</td>
              <td>{{ row.title }}</td>
              <td>{{ row.code }}</td>
              <td>{{ row.link }}</td>
              <td>{{ row.faculty }}</td>
              <td>{{ row.objective }}</td>
              <td>{{ row.startDate }}</td>
              <td>{{ row.endDate }}</td>
              <td>{{ row.location }}</td>
              <table>
                <tbody>
                  <tr *ngFor="let emp of row.empNames">
                    <td>{{ emp }}</td>
                  </tr>
                </tbody>
              </table>
            </tr>
          </tbody>
        </table>
        <table class="table-scroll  module-4" *ngIf="moduleName==4">
          <thead>
            <tr>
              <th> Program Title</th>  
              <th> Start Date</th> 
              <th> End Date</th> 
              <th>Mandays</th> 
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of totalMandays">
              <td>{{row.title}}</td>
              <td>{{row.startDate}}</td>
              <td>{{row.endDate}}</td>
              <td>{{row.mandays}}</td>
             </tr>
          </tbody>
        </table>

        <table class="table-scroll" *ngIf="moduleName==5">
          <thead>
            <tr>
              <th>Recommended By Whom</th>
              <th>Program Title</th>  
              <th>Programme Details</th> 
              <th>Programme brochure</th> 
              <th> Start Date</th> 
              <th> End Date</th> 
              <th>HR Admin comment</th> 
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of recommndedPrograms">
              <td>{{row.recommended}}</td>
              <td>{{row.title}}</td>
              <td>{{row.details}}</td>
              <td>{{row.brochure}}</td>
              <td>{{row.startDate}}</td>
              <td>{{row.endDate}}</td>
              <td>{{row.comment}}</td>
             </tr>
          </tbody>
        </table>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
